import { getTokens } from "@tamagui/core";
const getSpace = (token, sizeUpOrDownBy = 0) => {
  const spaces = getTokens().space;
  const spaceNames = Object.keys(spaces);
  const key = spaceNames[Math.max(0, spaceNames.indexOf(String(token || "$true")) + sizeUpOrDownBy)];
  return spaces[key] || spaces["$true"];
};
export {
  getSpace
};
//# sourceMappingURL=getSpace.js.map
